<template>
  <div>
    <list row-key="WarehouseId" ref="list" unit="解绑" :page="page" :query-params="params" 
      :reset-data-func="resetDataFunc"
      show-checkbox
      @check-change="checkChange"
      :show-query="showQuery" :get-data-func="api.surplusMaterialList">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="材料名称">
          <el-input v-model="params.ProductName" placeholder="请输入材料名称" clearable />
        </el-form-item>
        <el-form-item label="规格" > 
          <el-input v-model="params.ProductSpec" placeholder="请输入规格" clearable />
        </el-form-item>
        <el-form-item label="属性" >
          <el-input v-model="params.PropertyName" placeholder="请输入属性" clearable />
        </el-form-item>
        <el-form-item label="颜色" >
          <el-input v-model="params.ColorName" placeholder="请输入颜色" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="WorkDocNo" label="工单号" min-width="120px" align="center" />
        <el-table-column prop="ProductName" label="材料名称" min-width="120px" align="center" />
        <el-table-column prop="ProductNo" label="材料编码" min-width="120px" align="center" />
        <el-table-column prop="ProductSpec" label="规格" min-width="120px" align="center" />
        <el-table-column prop="PropertyName" label="属性" min-width="120px" align="center" />
        <el-table-column prop="ColorName" label="颜色" min-width="120px" align="center" />
        <el-table-column prop="MainQuantity" label="主数量" min-width="120px" align="right" />
        <el-table-column prop="Quantity" label="解绑数量" align="right" width="120" >
          <template slot-scope="{ row }">
            <el-input  v-model="row.Quantity" @change="changeQuantity(row)" type="number" />
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pr/prGetDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      data: {
        PrUnBindMaterialDetails: [],
        DocId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        WorkDocId: 0,
        EmpId: null
      },
      list: [],
      params: {
        ProductName: "",
        ProductSpec: "",
        PropertyName: "",
        ColorName: "",
      },
    };
  },
  methods: {
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("余料解绑单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取余料解绑单编号失败");
        }
      });
    },
    checkChange(list){
      this.list = list;
    },
    changeQuantity(row){
      if(row.Quantity > row.MainQuantity){
        row.Quantity = row.MainQuantity;
      }
      if(row.Quantity < 0){
        row.Quantity = row.MainQuantity;
      }
    },
    resetDataFunc(data){
      data.forEach(item => {
        item.MainQuantity = item.Quantity;
      })

      return data;
      
    },
    sendData(){

      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
      }


      let arr = [];
      this.list.forEach(item => {
        console.log('item', item)
        let o = {
          DetailId: 0,
          DocId: 0,
          ProductId: item.ProductId,
          ColorId: item.ColorId ?? 0,
          PropertyId: item.PropertyId ?? 0,
          UnitId: item.QuantityUnit ?? 0,
          UnitId2: item.Unit2 ?? 0,
          Quantity: item.Quantity,
          Quantity2: item.Quantity2 ?? 0,
          BaseQuantity: item.BaseQuantity ?? 0,
          SubQuantity: item.SubQuantity ?? 0,
          SubUnit: item.SubUnit ?? 0,
          BaseUnit: item.BaseUnit ?? 0,
          ChangeRate: item.Rate,
          SourceId: item.WorkDocId,
          SourceDtsId: item.WorkDocMaterialId,
        }

        arr.push(o)
      })
      
      this.data.PrUnBindMaterialDetails = arr;

      return this.data;
    } ,
    getData(WorkDocId){
      this.data.WorkDocId = WorkDocId;
      console.log('3 WorkDocId', WorkDocId)
      this.$nextTick(() => {
        this.$refs.list.getData({WorkDocId, ...this.params})
      })
      this.getPreviewNo();
    }
  },
};
</script>